import {ILanguage} from './interface';

const PATH = {
  DASHBOARD: '/',
  LOAN_DETAILS: '/loan-details',
  MY_LOANS: '/my-advance',
  LOAN_APPLICATION_PROCESS: '/loan-application-process',
  PAYMENTS_HISTORY: '/past-payment-history',
  RESUME_TEMPLATE_PATH: 'loan-application-process?loanApplicationId',
  PROFILE: '/my-profile',
  PAST_PAYMENT: '/repayment',
  DIRECT_DEBIT_SETUP: '/direct-debit-setup',
  POCKETS: '/my-pockets',
  PAYMENT: '/payment-details',
  PAYMENT_STATUS: '/payment-details/status',
  DOWNLOAD_TRANSACTION: '/download-transaction-summary',
};

const VERSIONS = {
  V1: '/api/v1',
};

const AUTH_API_ENDPOINTS = {
  LOGIN: '/merchant/auth/login',
  LOGOUT: '/merchant/auth/logout',
  SELECT_BIN: '/merchant/auth/select-bin',
  GET_COUNTRIES: '/merchant/auth/countries-list',
  VALIDATE_MOBILE: '/merchant/auth/validate-mob-email',
  IMAGE: '/aws/auth/partner-logo',
  MAINTENANCE: '/merchant/auth/maintenance',
  VALIDATE_MOBILE_REG: '/merchant/auth/validate-mob-register',
  TOKEN_VERIFY: '/google/auth/captcha-validation',
  BANK_LIST: '/direct-debit/auth/bank-list',
  COUNTRY_VALIDATION: '/direct-debit/auth/country-validations',
  BANK_DETAIL: '/direct-debit/auth/bank-details',
  DD_DETAIL: '/direct-debit/auth/user-details',
  PARTNER_DETAILS: '/merchant/auth/partner-details',
  RESEND_OTP: '/merchant/auth/send-otp',
  DECODE: '/payment/auth/decode-token',
  LOAN_DETAILS: '/payment/auth/loan-details',
  PAYMENT: '/payment/auth/repayment',
  PROMO_DETAILS: '/merchant/auth/promo-details',
  SAVE_CLICK: '/merchant/auth/save-click',
  IP_ADDRESS: '/merchant/auth/ip-address',
  POCKET_STATUS: '/merchant/auth/pocket-status',
  GET_POS_PARTNERS: '/merchant/auth/get-pos-partners',
  APPLY_POCKET: '/merchant/auth/apply-pocket',
  CHECK_APPLICATION_STATUS: '/merchant/auth/check-application-status',
  MAX_TRANSACTION_DATE: '/merchant/auth/max-transaction-date',
  LOAD_FORM: '/merchant/auth/load-smart-form',
  SUBMIT_FORM: '/merchant/auth/save-smart-form',
  FORM_OTP: '/merchant/auth/request-otp',
};

const API_ENDPOINTS = {
  LOAN_APPLICATION_CONFIG: '/loan-application/config',
  INITIALIZE: '/loan-application/initialize',
  LOAN_INFO: '/loan-application/update-loan',
  ELIGIBLE_PHONE_NUMBERS: '/loan-application/eligible-phone-numbers',
  SEND_OTP: '/loan-application/send-otp',
  VERIFY_OTP: '/loan-application/verify-otp',
  TNC: '/loan-application/tnc',
  GET_LOAN_REVIEW_DETAILS: '/loan-application/loan-review-details',
  PI_DATA: '/loan-application/pi-data',
  UPDATE_PI_DATA: '/loan-application/update-pi',
  SUBMIT_LOAN_APPLICATION: '/loan-application/submit',
  LOAN_LIMIT: '/loan/limits',
  RESUME_LOAN_OFFERS: '/loan-application/resume-loan-offers',
  GET_LOAN_DETAILS: '/loan/details',
  GET_TRANSACTIONS: '/loan/transactions',
  LOAN_COUNT: '/loan/list-count',
  LOAN_LISTS: '/loan/lists',
  PROFILE_DETAILS: '/merchant/profile',
  GET_BANK_LIST: '/loan-application/bank-list',
  CREATE_MANDATE: '/loan-application/create-mandate',
  BANK_DETAIL_SAVE: '/loan-application/bankDetailSave',
  BUSINESS_INFO_SAVE: '/merchant/dtm/businessInfo-save',
  DIRECTOR_DETAILS_SAVE: '/merchant/dtm/directorDetails-save',
  INDUSTRY_LIST: '/merchant/dtm/industry-list',
  SUB_INDUSTRY_LIST: '/merchant/dtm/sub-industry-list',
  STATES_LIST: '/merchant/dtm/state-list',
  GET_INSTALL_URL: '/merchant/dtm/get-install-url',
  GET_VALIDATION: '/merchant/dtm/countryValidations',
  GET_PII_DETAILS: '/merchant/dtm/getPiiDetails',
  GET_PLATFORM_LIST: '/merchant/dtm/platformList',
  UPDATE_TO_PID: '/merchant/dtm/update-to-pid',
  LENDERS_DATA: '/loan-application/lenders-list',
  TOPUP_INITIALIZE: '/loan-application/topup-initialize',
  STEPIN_OFFER: '/loan-application/stepin-offer',
  PAYMENT: '/loan/repayment',
  PLATFORM_FEE: '/loan-application/platform-fee',
  FEE_TNC: '/loan-application/fee-tnc',
  PLATFORM_FEE_CONFIG: '/loan-application/platform-fee-config',
  TOPUP_LIMIT: '/loan/topup-limits',
  GET_BANK_DETAILS: '/loan-application/bank-details',
  UPLOAD: '/loan-application/upload',
  FULL_PII: '/merchant/full-profile',
  UPDATE_FULL_PII: '/merchant/save-profile',
  MANDATE_STATUS: '/loan-application/mandate-status',
  PURPOSE_LIST: '/loan-application/purpose-list',
  SAVE_PURPOSE: '/loan-application/save-purpose',
  TRANSACTIONS_SUMMARY: '/loan/transaction-summary',
};

const CARD_MESSAGE = {
  EMPTY_lOAN_CARD_TEXT: 'You do not have any active advances',
};

const LOAN_APPLICATION_STEPS = [
  'Select  Advance Amount',
  'Select Your Tenure',
  'Review Your Advance Details',
  'Confirm Mobile Number',
  'Confirm Personal Details',
  'Terms & Conditions',
];

const LOAN_APPLICATION_STEPS_KEYS = {
  TENURE: 'step_2.tenure',
  SLIDER: 'step_1.showSlider',
  OFFER: 'step_2.showOffer',
  TOPUP_DETAILS: 'step_3.topupDetails',
  NUMBER: 'step_4.mobileNumber',
  MOBILEID: 'step_4.mobileId',
  OTP: 'step_5.otp',
  CAM_ERROR: 'step_6.camError',
  CAPTURE_ID: 'step_6.idCapture',
  CAPTURE_SELFIE: 'step_6.selfieCapture',
};

const INITIAL_LOAN_DATA = {
  id: '',
  loanStatus: '',
  bankName: '',
  dsr: '',
  van: '',
  loanType: '',
  currency: '',
  mpId: '',
  remainingRepaymentAmountTillDate: 0,
  repaidPercentageTillDate: 0,
  shortfallPercentageTillDate: 0,
  overduePercentageTillDate: 0,
  repaidAmountTillDate: 0,
  loanAmount: 0,
  tenureInWeeks: '',
  grossLoanAmount: 0,
  repaymentThrough: '',
  expected_first_repayment_date: '',
  actual_first_repayment_date: '',
  expected_last_repayment_date: '',
  estimated_last_repayment_date: '',
  actual_last_repayment_date: '',
  shortfallAmountTillDate: 0,
  overdueAmountTillDate: 0,
  expectedWeeklyRepaymentAmount: 0,
  vanRoutingCodeType: '',
  vanRoutingCodeValue: '',
  expectedRepaymentAmountTillDate: 0,
  fourWeeklyMinimumRepaymentAmount: 0,
  fourWeeklyMinimumRepaymentAmountTillDate: 0,
};

const WHATS_APP_NUMBER = '+601117226265';
const WHATS_APP_NUMBER_ID = '+6281479013198';

const CHANNEL = {
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP',
  EMAIL: 'EMAIL',
};

const LOGIN_PATNERS = [
  'senangPay',
  'curlec',
  'Curlec',
  'FinMatch',
  'finmatch',
  'Pine Labs',
  'MobilityOne Sdn Bhd',
  'EasyEat',
  'LOLA',
  'Chip',
  'CHIP',
  'DOKU',
  'MyDataHub',
  'Remedi',
  'Rintisan',
  'Popcorn',
];

const domainToCountryCodeMap: {[key: string]: string} = {
  'app.seedflex.com': 'MY',
  'app.seedflex.id': 'ID',
  'stagingapp.seedflex.com': 'MY',
  'stagingapp.seedflex.id': 'ID',
  'qafe.seedflex.com': 'MY',
  'qafe.seedflex.id': 'ID',
  'qafe-th.seedflex.com': 'TH',
  'stagingapp.jaidee.co.th': 'TH',
  'app.jaidee.co.th': 'TH',
  localhost: 'MY',
};

const currentCountry =
  typeof window !== 'undefined'
    ? Object.keys(domainToCountryCodeMap).find((domain) =>
        window.location.hostname.endsWith(domain)
      )
      ? domainToCountryCodeMap[
          Object.keys(domainToCountryCodeMap).find((domain) =>
            window.location.hostname.endsWith(domain)
          )!
        ]
      : 'MY'
    : 'MY';

const LANGUAGES: ILanguage[] = [
  {key: 1, value: 'en', text: 'Language - English'},
  ...(currentCountry === 'ID'
    ? [{key: 2, value: 'id', text: 'Bahasa - Bahasa Indonesia'}]
    : []),
  ...(currentCountry === 'TH'
    ? [{key: 3, value: 'th', text: 'ภาษา - ภาษาไทย'}]
    : []),
  ...(currentCountry === 'MY'
    ? [{key: 4, value: 'ms', text: 'Bahasa - Bahasa Melayu'}]
    : []),
];

const FONT = {
  NUNITO: 'Nunito Sans',
};

const SCREEN_TEXT = [
  {
    partner_id: '10011123101',
    prefix_text: 'In Partnership with',
    display_text: 'Boost',
  },
];

const LIMIT_EXPIRED_DAYS = 40;
const LIMIT_REACTIVE_MONTHS = 1;

const APP_MAP: {[key: string]: string} = {
  boost: 'boost',
  indrive: 'indrive',
  localhost: 'default',
};

export {
  PATH,
  CARD_MESSAGE,
  LOAN_APPLICATION_STEPS,
  VERSIONS,
  API_ENDPOINTS,
  AUTH_API_ENDPOINTS,
  LOAN_APPLICATION_STEPS_KEYS,
  INITIAL_LOAN_DATA,
  WHATS_APP_NUMBER,
  WHATS_APP_NUMBER_ID,
  CHANNEL,
  LOGIN_PATNERS,
  LANGUAGES,
  domainToCountryCodeMap,
  currentCountry,
  FONT,
  SCREEN_TEXT,
  APP_MAP,
  LIMIT_EXPIRED_DAYS,
  LIMIT_REACTIVE_MONTHS,
};
